import { useEffect, useState } from "react";
import { POPUP_EVENT } from "../utils/popup";

function GlobalPopup() {
  const [popup, setPopup] = useState(null);

  useEffect(() => {
    const handlePopup = (event) => {
      setPopup(event.detail);
    };

    window.addEventListener(POPUP_EVENT, handlePopup);
    return () => window.removeEventListener(POPUP_EVENT, handlePopup);
  }, []);

  if (!popup) return null;

  return (
    <div className="appPopupOverlay" role="dialog" aria-modal="true">
      <div className={`appPopup appPopup-${popup.type || "info"}`}>
        <h2>{popup.title || "Aviso"}</h2>
        <p>{popup.message}</p>
        <button type="button" onClick={() => setPopup(null)}>
          Aceptar
        </button>
      </div>
    </div>
  );
}

export default GlobalPopup;
